// Extract a DOI from PDF first-page text via pdf.js. The backend
// re-extracts on the upload endpoint and trusts its own value, so this
// is a best-effort hint — failures cascade to backend re-extract +
// title-match fallback.

import { PDFJS_WORKER_SRC } from "@/lib/pdfjs-assets";

const DOI_RE = /10\.\d{4,9}\/[^\s"<>]+/i;

export function extractDoiFromText(text: string): string | null {
  const m = DOI_RE.exec(text);
  return m ? m[0].replace(/[.,;)\]]+$/, "") : null;
}

export async function extractDoiFromPdfBlob(blob: Blob): Promise<string | null> {
  try {
    const { getDocument, GlobalWorkerOptions } = await import("pdfjs-dist");
    if (!GlobalWorkerOptions.workerSrc) {
      GlobalWorkerOptions.workerSrc = PDFJS_WORKER_SRC;
    }
    const arrayBuffer = await blob.arrayBuffer();
    const pdf = await getDocument({ data: arrayBuffer }).promise;
    if (pdf.numPages === 0) return null;
    const page = await pdf.getPage(1);
    const content = await page.getTextContent();
    const text = (content.items as Array<{ str?: string }>)
      .map((it) => it.str ?? "")
      .join(" ");
    return extractDoiFromText(text);
  } catch {
    return null;
  }
}
